import React, { useState, useEffect } from "react";
import axiosClient from "../../../utilities/axios_client";
import { Button, Link, Text } from "../../../groundworkui-ui";
import { UiKitPreview } from "../../ui_kit_components";
import Settings from "./settings";
import { Icon } from "@iconify/react";

const ProjectsShow = ({ projectId }) => {
  const demoMode = !projectId;

  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState();

  const [uiKitConfiguration, setUiKitConfiguration] = useState();

  const [changesSinceLastSave, setChangesSinceLastSave] = useState(false);

  const loadProject = () => {
    axiosClient.get(`/projects/${projectId}`).then((response) => {
      setProject(response.data);

      if (response.data.current_ui_kit_configuration) {
        setUiKitConfiguration(response.data.current_ui_kit_configuration);
      }

      setLoading(false);
    });
  };

  const handleSave = () => {
    axiosClient
      .post(`/projects/${projectId}/ui_kit_configurations`, {
        ui_kit_configuration: uiKitConfiguration,
      })
      .then((response) => {
        window.alert("Saved!");
        setChangesSinceLastSave(false);
      })
      .catch((error) => {
        window.alert(`Error saving: ${error.message}`);
      });
  };

  useEffect(() => {
    setChangesSinceLastSave(true);
  }, [uiKitConfiguration]);

  useEffect(() => {
    if (demoMode) {
      axiosClient.get("/color_packs").then((response) => {
        setLoading(false);
        setUiKitConfiguration({
          colors: response.data[0].colors,
        });
      });
    } else {
      loadProject();
    }
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!demoMode && !project) {
    return <div>Project not found</div>;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="h-8 flex bg-slate-300 items-center px-4 justify-between">
        <div className="font-bold">
          {demoMode ? (
            "Demo Project"
          ) : (
            <div className="inline-flex items-center gap-8">
              <a
                href="/projects"
                className="inline-flex items-center gap-1 font-normal"
              >
                <Icon icon="mdi:chevron-left-circle" /> Projects
              </a>{" "}
              {project.name}
            </div>
          )}
        </div>
        <div className="flex gap-2 items-center ">
          {demoMode ? (
            <>
              <div>
                Got a good taste of what GroundworkUI can do? Sign up so you can
                start using your design in a project
              </div>
              <Button size="small" href={"/users/sign_up"}>
                Sign up now
              </Button>
            </>
          ) : (
            <>
              <Link href={`/projects/${project.id}/ui_kit_configurations`}>
                Version History
              </Link>
              <Button
                size="small"
                href={`/projects/${project.id}/deployment_environments`}
              >
                Publish
              </Button>
              <Button
                size="small"
                onClick={handleSave}
                disabled={!changesSinceLastSave}
              >
                Save
              </Button>
            </>
          )}
        </div>
      </div>
      <div className="flex h-[calc(100vh-7rem)]">
        <div className="flex h-full gap-2 flex-col border-r border-gray-600 p-4 overflow-y-scroll w-80">
          <Text type="h2">Settings</Text>

          <Settings
            initialUiKitConfiguration={uiKitConfiguration}
            onChange={(newUiKitConfiguration) =>
              setUiKitConfiguration(newUiKitConfiguration)
            }
          />
        </div>
        <div className="flex-grow p-4 h-full overflow-y-scroll">
          <Text type="h2">Preview</Text>
          <UiKitPreview uiKitConfiguration={uiKitConfiguration} />
        </div>
      </div>
    </div>
  );
};

export default ProjectsShow;
